<div [formGroup]="parentForm">
  <wsd-extended-input label="{{ label | translate }}"
                     [control]="parentForm.get('organization')">
    <p-dropdown [options]="organizationItems"
                placeholder="{{ 'SELECT_ORGANIZATION.PLACEHOLDER' | translate }}"
                formControlName="organization">
    </p-dropdown>
  </wsd-extended-input>
</div>
